var map = {
	"./化学bg@2x.png": "d7e97",
	"./历史bg@2x.png": "0e5e",
	"./地理bg@2x.png": "1f8e",
	"./思想政治bg@2x.png": "2f92",
	"./政治bg@2x.png": "b869",
	"./数学bg@2x.png": "24a1",
	"./文科数学bg@2x.png": "09cd",
	"./物理bg@2x.png": "d2dc",
	"./理科数学bg@2x.png": "acfe",
	"./生物bg@2x.png": "01b3",
	"./生物学bg@2x.png": "cd49",
	"./英语bg@2x.png": "822f",
	"./语文bg@2x.png": "d185"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c94";